import React from "react";
import { baseUrl } from "../Api/Api";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  categories: {
    marginBottom: theme.spacing(1),
  },
  card: {
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover, &.active": {
      cursor: "pointer",
      backgroundColor: theme.palette.secondary.light,
    },
  },
}));

const LpCategories = () => {
  const classes = useStyles();

  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [categories, setCategories] = React.useState([]);

  React.useEffect(() => {
    const homepageUrl = baseUrl + "/homepage";
    const homepageRequest = axios.get(homepageUrl);
    setLoading(true);
    axios
      .all([homepageRequest])
      .then(
        axios.spread((...responses) => {
          setCategories(responses[0].data.categories);
          setLoading(false);
        })
      )
      .catch((errors) => {
        setError(errors);
        setLoading(false);
      });
  }, []);

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="stretch"
      spacing={2}
      className={classes.categories}
    >
      {categories
        .filter((category) => {
          return category.schoolType.slug === "vysoka-skola";
        })
        .map((category) => {
          return (
            <Grid item xs={12} sm={6} md={3} key={categories.indexOf(category)}>
              <Card
                component={Link}
                to={"kategorie/" + category.slug}
                style={{ display: "block", textDecoration: "none" }}
                className={classes.card}
              >
                <Typography variant={"subtitle1"}>{category.title}</Typography>
                <Typography variant={"caption"}>{category.subtitle}</Typography>
              </Card>
            </Grid>
          );
        })}
    </Grid>
  );
};

export default LpCategories;
